export default __webpack_public_path__ + "static/media/placeholder_dummy2016-tennisclub01-mobile-de.3abc3d11.png";